import { useLocalStorage } from '@ai-tutor/ui';
import { localDateKey, useWellbeingKeys } from '../wellbeingStorage';
import type { MoodId } from './moods';

interface StoredMood {
  date: string;
  mood: MoodId;
}

/**
 * Today's mood check-in, and nothing older - yesterday's mood is not today's,
 * and a history of moods is sensitive data we chose not to keep. On this
 * device only.
 */
export function useTodaysMood(): [MoodId | null, (mood: MoodId) => void] {
  const keys = useWellbeingKeys();
  const [stored, setStored] = useLocalStorage<StoredMood | null>(
    keys.mood,
    null
  );
  const today = localDateKey(Date.now());
  const mood = stored?.date === today ? stored.mood : null;
  return [mood, next => setStored({ date: today, mood: next })];
}
